import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>NEXPA</h3>
            <p className="footer-tagline">Literacy Intelligence for the Next Generation</p>
            <p>AI 기반 문해력 혁신을 선도하는 교육기술 기업</p>
          </div>
          
          <div className="footer-section">
            <Link to="/products" className="footer-header-link">
              <h4>플랫폼</h4>
            </Link>
            <ul>
              <li><a href="/products">LIDIA Literacy System</a></li>
              <li><a href="/products">NEXPA MAP</a></li>
              <li><a href="/products">NEXPA Edu</a></li>
              <li><a href="/products">LIDIA Solutions</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <Link to="/about" className="footer-header-link">
              <h4>회사</h4>
            </Link>
            <ul>
              <li><a href="/about">회사소개</a></li>
              <li><a href="/about">비전</a></li>
              <li><a href="/contact">파트너십</a></li>
              <li><a href="/contact">채용정보</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <Link to="/contact" className="footer-header-link">
              <h4>연락처</h4>
            </Link>
            <ul>
              <li>NEXPA Team</li>
              <li>주소 : 서울시 서초구 강남대로 107길 21, 2층</li>
              <li>전화 : 02-6207-7400</li>
              <li>이메일 : ceo@nexpa-ai.com</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-info">
            <p>주식회사 넥스파 (NEXPA Inc.) | 대표 : 김은석 | 주소 : 서울시 서초구 강남대로 107길 21, 2층</p>
            <p>&copy; {currentYear} NEXPA Inc. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 